import { render } from "./NewsMain.vue?vue&type=template&id=b867880a&scoped=true"
import script from "./NewsMain.vue?vue&type=script&lang=js"
export * from "./NewsMain.vue?vue&type=script&lang=js"

import "./NewsMain.vue?vue&type=style&index=0&id=b867880a&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b867880a"]])

export default __exports__